/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createTndAccount = /* GraphQL */ `
  mutation CreateTndAccount(
    $input: CreateTndAccountInput!
    $condition: ModelTndAccountConditionInput
  ) {
    createTndAccount(input: $input, condition: $condition) {
      id
      enabled
      location
      description
      loginId
      loginPassword
      apiKey
      users
    }
  }
`;
export const updateTndAccount = /* GraphQL */ `
  mutation UpdateTndAccount(
    $input: UpdateTndAccountInput!
    $condition: ModelTndAccountConditionInput
  ) {
    updateTndAccount(input: $input, condition: $condition) {
      id
      enabled
      location
      description
      loginId
      loginPassword
      apiKey
      users
    }
  }
`;
export const deleteTndAccount = /* GraphQL */ `
  mutation DeleteTndAccount(
    $input: DeleteTndAccountInput!
    $condition: ModelTndAccountConditionInput
  ) {
    deleteTndAccount(input: $input, condition: $condition) {
      id
      enabled
      location
      description
      loginId
      loginPassword
      apiKey
      users
    }
  }
`;
export const createSensorName = /* GraphQL */ `
  mutation CreateSensorName(
    $input: CreateSensorNameInput!
    $condition: ModelSensorNameConditionInput
  ) {
    createSensorName(input: $input, condition: $condition) {
      serial
      name
      ch1
      ch2
    }
  }
`;
export const updateSensorName = /* GraphQL */ `
  mutation UpdateSensorName(
    $input: UpdateSensorNameInput!
    $condition: ModelSensorNameConditionInput
  ) {
    updateSensorName(input: $input, condition: $condition) {
      serial
      name
      ch1
      ch2
    }
  }
`;
export const deleteSensorName = /* GraphQL */ `
  mutation DeleteSensorName(
    $input: DeleteSensorNameInput!
    $condition: ModelSensorNameConditionInput
  ) {
    deleteSensorName(input: $input, condition: $condition) {
      serial
      name
      ch1
      ch2
    }
  }
`;
export const createSensorDayReading = /* GraphQL */ `
  mutation CreateSensorDayReading(
    $input: CreateSensorDayReadingInput!
    $condition: ModelSensorDayReadingConditionInput
  ) {
    createSensorDayReading(input: $input, condition: $condition) {
      serial
      localDate
      tndAccountLoginId
      name
      utcOffsetMinutes
      readings {
        dataId
        unixtime
        reading
      }
      channel2Name
      channel2Readings {
        dataId
        unixtime
        reading
      }
    }
  }
`;
export const updateSensorDayReading = /* GraphQL */ `
  mutation UpdateSensorDayReading(
    $input: UpdateSensorDayReadingInput!
    $condition: ModelSensorDayReadingConditionInput
  ) {
    updateSensorDayReading(input: $input, condition: $condition) {
      serial
      localDate
      tndAccountLoginId
      name
      utcOffsetMinutes
      readings {
        dataId
        unixtime
        reading
      }
      channel2Name
      channel2Readings {
        dataId
        unixtime
        reading
      }
    }
  }
`;
export const deleteSensorDayReading = /* GraphQL */ `
  mutation DeleteSensorDayReading(
    $input: DeleteSensorDayReadingInput!
    $condition: ModelSensorDayReadingConditionInput
  ) {
    deleteSensorDayReading(input: $input, condition: $condition) {
      serial
      localDate
      tndAccountLoginId
      name
      utcOffsetMinutes
      readings {
        dataId
        unixtime
        reading
      }
      channel2Name
      channel2Readings {
        dataId
        unixtime
        reading
      }
    }
  }
`;
export const createLastSensorUnixTime = /* GraphQL */ `
  mutation CreateLastSensorUnixTime(
    $input: CreateLastSensorUnixTimeInput!
    $condition: ModelLastSensorUnixTimeConditionInput
  ) {
    createLastSensorUnixTime(input: $input, condition: $condition) {
      serial
      unixtime
      name
      tndAccountLoginId
      lastCheckUnixtime
    }
  }
`;
export const updateLastSensorUnixTime = /* GraphQL */ `
  mutation UpdateLastSensorUnixTime(
    $input: UpdateLastSensorUnixTimeInput!
    $condition: ModelLastSensorUnixTimeConditionInput
  ) {
    updateLastSensorUnixTime(input: $input, condition: $condition) {
      serial
      unixtime
      name
      tndAccountLoginId
      lastCheckUnixtime
    }
  }
`;
export const deleteLastSensorUnixTime = /* GraphQL */ `
  mutation DeleteLastSensorUnixTime(
    $input: DeleteLastSensorUnixTimeInput!
    $condition: ModelLastSensorUnixTimeConditionInput
  ) {
    deleteLastSensorUnixTime(input: $input, condition: $condition) {
      serial
      unixtime
      name
      tndAccountLoginId
      lastCheckUnixtime
    }
  }
`;
export const createSensorCheckoutControl = /* GraphQL */ `
  mutation CreateSensorCheckoutControl(
    $input: CreateSensorCheckoutControlInput!
    $condition: ModelSensorCheckoutControlConditionInput
  ) {
    createSensorCheckoutControl(input: $input, condition: $condition) {
      serial
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const updateSensorCheckoutControl = /* GraphQL */ `
  mutation UpdateSensorCheckoutControl(
    $input: UpdateSensorCheckoutControlInput!
    $condition: ModelSensorCheckoutControlConditionInput
  ) {
    updateSensorCheckoutControl(input: $input, condition: $condition) {
      serial
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const deleteSensorCheckoutControl = /* GraphQL */ `
  mutation DeleteSensorCheckoutControl(
    $input: DeleteSensorCheckoutControlInput!
    $condition: ModelSensorCheckoutControlConditionInput
  ) {
    deleteSensorCheckoutControl(input: $input, condition: $condition) {
      serial
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const createSensorCheckoutRecord = /* GraphQL */ `
  mutation CreateSensorCheckoutRecord(
    $input: CreateSensorCheckoutRecordInput!
    $condition: ModelSensorCheckoutRecordConditionInput
  ) {
    createSensorCheckoutRecord(input: $input, condition: $condition) {
      serial
      localDate
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const updateSensorCheckoutRecord = /* GraphQL */ `
  mutation UpdateSensorCheckoutRecord(
    $input: UpdateSensorCheckoutRecordInput!
    $condition: ModelSensorCheckoutRecordConditionInput
  ) {
    updateSensorCheckoutRecord(input: $input, condition: $condition) {
      serial
      localDate
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const deleteSensorCheckoutRecord = /* GraphQL */ `
  mutation DeleteSensorCheckoutRecord(
    $input: DeleteSensorCheckoutRecordInput!
    $condition: ModelSensorCheckoutRecordConditionInput
  ) {
    deleteSensorCheckoutRecord(input: $input, condition: $condition) {
      serial
      localDate
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      username
      email
      name
      city
      company
      department
      post
      phone
      privileges
      tndAccountLoginIds
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      username
      email
      name
      city
      company
      department
      post
      phone
      privileges
      tndAccountLoginIds
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      username
      email
      name
      city
      company
      department
      post
      phone
      privileges
      tndAccountLoginIds
    }
  }
`;
